import { GridFilterModel, DataGrid as MuiDataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import {
  getCommonDataGridProps,
  ICommonDataGridProps,
  ITEMS_PER_PAGE,
  mapColumnsToCommon,
  mapRowsToCommon,
  WithId,
} from "./common";

interface IProps<T extends WithId> extends ICommonDataGridProps<T> {
  filterModel?: GridFilterModel;
  onFilterModelChange?: (model: GridFilterModel) => void;
}

export const DataGrid = <T extends WithId>({
  rows,
  columns,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
  onSelectedRowsChange,
  rowHeight,
  filterModel,
  onFilterModelChange,
  onRowClick,
  disabledRowIds,
  getRowHeight,
  pageSizeInitial,
  hidePageSizeText,
}: IProps<T>): React.ReactElement<IProps<T>> => {
  const [innerPage, setInnerPage] = useState(0);
  const [innerPageSize, setInnerPageSize] = useState(
    pageSizeInitial ?? ITEMS_PER_PAGE
  );
  const commonProps = getCommonDataGridProps(onRowClick, disabledRowIds, undefined, hidePageSizeText);

  return (
    <MuiDataGrid<T>
      filterModel={filterModel}
      onFilterModelChange={onFilterModelChange}
      filterMode="client"
      sortingMode="client"
      paginationMode="client"
      disableRowSelectionOnClick
      rows={mapRowsToCommon(rows)}
      columns={mapColumnsToCommon(columns)}
      rowHeight={rowHeight}
      getRowHeight={getRowHeight}
      onRowSelectionModelChange={onSelectedRowsChange}
      rowSelection={Boolean(onSelectedRowsChange)}
      checkboxSelection={Boolean(onSelectedRowsChange)}
      paginationModel={{ page: innerPage, pageSize: innerPageSize }}
      onPaginationModelChange={({ page, pageSize }) => {
        if (page !== innerPage) {
          setInnerPage(page);
          onPageChange?.(page);
        }

        if (pageSize !== innerPageSize) {
          setInnerPageSize(pageSize);
          onPageSizeChange?.(pageSize);
        }
      }}
      pageSizeOptions={pageSizeOptions ?? [5, 10, 20, 40]}
      {...commonProps}
    />
  );
};
